import Route from '@ember/routing/route';

export default class TaktikRoute extends Route {}
